import React from 'react';
import PropTypes from 'prop-types';
import Select from './Select';

class SelectMinMax extends React.PureComponent {
  constructor(props) {
    super(props);
    this.min = props.minName;
    this.max = props.maxName;
  }

  handleMinChange = event => {
    const maxCurrent = this.props.maxSelectedOption;
    const value = parseInt(event.target.value, 10);
    const res = {
      [this.min]: value,
      [this.max]: value > maxCurrent ? 0 : maxCurrent,
    };
    this.props.minOnChange(null, res);
  };

  handleMaxChange = event => {
    const minCurrent = this.props.minSelectedOption;
    const value = parseInt(event.target.value, 10);
    const res = {
      [this.min]: value < minCurrent && value !== 0 ? 0 : minCurrent,
      [this.max]: value,
    };
    this.props.maxOnChange(null, res);
  };

  render() {
    const {
      minOptions,
      minName,
      minPlaceholder,
      minSelectedOption,
      maxOptions,
      maxName,
      maxSelectedOption,
      maxPlaceholder,
      toString,
      size,
      style,
    } = this.props;

    return (
      <div className={`wrp clearfix ${size}`}>
        <span>
          <Select
            options={minOptions}
            name={minName}
            size={size}
            selectedOption={minSelectedOption}
            markAsActive={minSelectedOption}
            onChange={this.handleMinChange}
            placeholder={minPlaceholder}
            placeholderValue={0}
            style={style}
          />
        </span>
        <span className="to">{toString}</span>
        <span>
          <Select
            options={maxOptions}
            name={maxName}
            size={size}
            selectedOption={maxSelectedOption}
            markAsActive={maxSelectedOption}
            onChange={this.handleMaxChange}
            placeholder={maxPlaceholder}
            placeholderValue={0}
            style={style}
          />
        </span>
        <style jsx>
          {`
            .wrp {
              width: 100%;
            }
            span {
              float: left;
              width: 44%;
            }
            span.to {
              text-align: center;
              width: 12%;
            }
            .small span.to {
              font-size: 0.8125em; /* 13/16 */
              padding: 0.65em 0;
            }
            .medium span.to {
              font-size: 0.9375em; /* 15/16 */
              padding: 0.75em 0;
            }
            .big span.to {
              font-size: 1em; /* 16/16 */
              padding: 1em 0;
            }
          `}
        </style>
      </div>
    );
  }
}

SelectMinMax.defaultProps = {
  minSelectedOption: 0,
  minPlaceholder: undefined,
  maxSelectedOption: 0,
  maxPlaceholder: undefined,
  toString: '-',
  size: 'medium',
  style: null,
};

SelectMinMax.propTypes = {
  minName: PropTypes.string.isRequired,
  minOptions: PropTypes.object.isRequired,
  minSelectedOption: PropTypes.number,
  minOnChange: PropTypes.func.isRequired,
  minPlaceholder: PropTypes.string,
  maxName: PropTypes.string.isRequired,
  maxOptions: PropTypes.object.isRequired,
  maxSelectedOption: PropTypes.number,
  maxOnChange: PropTypes.func.isRequired,
  maxPlaceholder: PropTypes.string,
  toString: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.object,
};

export default SelectMinMax;



// WEBPACK FOOTER //
// ./app/common/forms/SelectMinMax.js